export default "__VITE_ASSET__DLN5_T77__"